import ElDrawer from '@/components/ElDrawer/index'
import ElDialog from '@/components/ElDialog/index'
import UploadFile from '@/components/UploadFile/index'
import UploadImg from '@/components/UploadFile/UploadImg'

// 组件必须设置name
const componentList = [
  ElDrawer,
  ElDialog,
  UploadFile,
  UploadImg
]
export default {
    install(app) {
        componentList.map(item => {
            app.component(item.name,item);
        })
    }
}